namespace $.$$ {
	export class $shm_hitalama_map_widget_float_component_parser extends $.$shm_hitalama_map_widget_float_component_parser {
		
		run() {
			const x = this.left() + this.width() + 10
			const y = this.top()

			const obj = JSON.parse( this.code() ) as AI_answer

			obj.ts_classes.forEach( (c, i) => {
				const code = create_class( c )
				
				const widget = this.map().widget_add( 'component', [x, y + 410*i ], 600, 400 )
				widget?.text( code )
				widget?.title( c.class_name )
			} )
			// console.log( obj.ts_classes )
			// console.log( create_class( obj.ts_classes[0] ) )
		}
		
	}

	type AI_answer = {
		ts_classes: {
			class_name: string,
			extends: string,
			methods: {
				name: string,
				params: '' | string,
				decorator: '' | '$mol_mem' | '$mol_mem_key',
				body: string,
			}[],
		}[],
		css_selectors: {
			selector: string,
			body: string,
		}[],
	}
	
	function create_class( obj: AI_answer['ts_classes'][number] ): string {
		const { class_name, extends: extendsClass, methods } = obj;
		
		const methodsCode = methods.map(method => {
			const { name, params, decorator, body } = method;
			
			const formattedBody = body
				.split('\n')
				.map(line => `        ${line}`)
				.join('\n');
			
			let methodCode = '';
			if (decorator) {
				methodCode += `    @ ${decorator}\n`;
			}
			methodCode += `    ${name}(${params || ''}) {\n`;
			methodCode += `${formattedBody}\n`;
			methodCode += `    }`;
			
			return methodCode;
		}).join('\n\n');
		
		// Формируем объявление наследования
		const extendsDeclaration = extendsClass ? ` extends ${extendsClass}` : '';
		
		// Собираем полный код класса
		return `class ${class_name}${extendsDeclaration} {\n${methodsCode}\n}`;
	}

}
